// extracted by mini-css-extract-plugin
export default {"about":"styles_about__VhcDJ","title__container":"styles_title__container__9RKSn","item__img":"styles_item__img__aaa+p","item__content":"styles_item__content__Kfk+e"};